<div class="row m-4 justify-content-center center d-flex">
    <mat-checkbox
        [checked]="checklistSelection.isSelected(globalNode)"
        (change)="checklistSelection.toggle(globalNode);"
        class="col-auto checklist-leaf-node" translate>All notifications</mat-checkbox>
    <mat-slide-toggle class="col-auto accent"
        [checked]="checklistSoundSelection.isSelected(globalNode)"
        (change)="checklistSoundSelection.toggle(globalNode);"
        [disabled]="!checklistSelection.isSelected(globalNode)"
        translate>All sounds</mat-slide-toggle>
    <mat-slide-toggle 
        [checked]="checklistVibrationSelection.isSelected(globalNode)"
        (change)="checklistVibrationSelection.toggle(globalNode);"
        [disabled]="!checklistSelection.isSelected(globalNode)"
        class="col-auto" translate>All vibrations</mat-slide-toggle>
    <button class="col-auto pink btn" (click)="resetAll()">
        <img class="mr-1" src="/assets/images/redo.svg" />
        {{'Reset all' | translate}}
    </button>
</div>
<div class="row">
    <div class="col-12">
        <div [ngClass]="{'two-columns': globalNode.id == 'AUTOMATIC'}">
            <div class="tree-header tree-row" [ngClass]="{'first-column-0': globalNode.id != 'CARDIAC'}">
                <div></div>
                <div class="item-name" translate>Alert name</div>
                <div class="control" translate>Notifications</div>
                <div class="control" translate>Sound</div>
                <div class="control">Vibration</div>
            </div>

            <div  *ngIf="globalNode.id == 'AUTOMATIC'" class="tree-header tree-row" [ngClass]="{'first-column-0': globalNode.id != 'CARDIAC'}">
                <div></div>
                <div class="item-name" translate>Alert name</div>
                <div class="control" translate>Notifications</div>
                <div class="control" translate>Sound</div>
                <div class="control">Vibration</div>
            </div>
        </div>
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" [ngClass]="{'two-columns': globalNode.id == 'AUTOMATIC'}">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding class="tree-row"
                [ngClass]="{'first-column-0': globalNode.id != 'CARDIAC'}">
                <div>
                    <button mat-icon-button disabled></button>
                </div>
                <div class="item-name node-border-bottom">{{node.item}}</div>
                <div class="control node-border-bottom">
                    <mat-checkbox 
                        class="checklist-leaf-node"
                        [checked]="checklistSelection.isSelected(node)"
                        (change)="checklistSelection.toggle(node);"
                        [disabled]="!checklistSelection.isSelected(globalNode)"
                    ></mat-checkbox>
                </div>
                <div class="control node-border-bottom">
                    <mat-slide-toggle 
                        [checked]="checklistSoundSelection.isSelected(node)"
                        (change)="checklistSoundSelection.toggle(node);"
                        [disabled]="!checklistSoundSelection.isSelected(globalNode) || !checklistSelection.isSelected(globalNode)"
                    ></mat-slide-toggle></div>
                <div class="control node-border-bottom">
                    <mat-slide-toggle 
                        [checked]="checklistVibrationSelection.isSelected(node)"
                        (change)="checklistVibrationSelection.toggle(node);"
                        [disabled]="!checklistVibrationSelection.isSelected(globalNode) || !checklistSelection.isSelected(globalNode)"
                    ></mat-slide-toggle>
                </div>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding class="tree-row"
                [ngClass]="{'first-column-0': globalNode.id != 'CARDIAC'}"
            >
                <div class="node-border-bottom">
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.filename">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                        </mat-icon>
                    </button>
                </div>
                <div class="item-name node-border-bottom">{{node.item}}</div>
                <div class="control node-border-bottom">
                    <mat-checkbox 
                        [checked]="descendantsAllSelected(node)"
                        [indeterminate]="descendantsPartiallySelected(node)"
                        [disabled]="!checklistSelection.isSelected(globalNode)"
                        (change)="todoItemSelectionToggle(node)"></mat-checkbox>
                </div>
                <div class="control node-border-bottom">
                    <mat-slide-toggle class="tri-toggle" [checked]="descendantsAllSoundSelected(node)"
                        [indeterminate]="descendantsPartiallySelected(node)"
                        [class.indeterminate]="descendantsPartiallySoundSelected(node)"
                        [disabled]="!checklistSelection.isSelected(globalNode) || !checklistSoundSelection.isSelected(globalNode)"
                        (change)="todoItemSoundSelectionToggle(node)"></mat-slide-toggle>
                </div>
                <div class="control node-border-bottom">
                    <mat-slide-toggle class="tri-toggle" [checked]="descendantsAllVibrationSelected(node)"
                        [indeterminate]="descendantsPartiallySelected(node)"
                        [class.indeterminate]="descendantsPartiallyVibrationSelected(node)"
                        [disabled]="!checklistSelection.isSelected(globalNode) || !checklistVibrationSelection.isSelected(globalNode)"
                        (change)="todoItemVibrationSelectionToggle(node)"></mat-slide-toggle>
                </div>
            </mat-tree-node>
        </mat-tree>
    </div>
</div>